export default {
    pages: {
        321: [
            {
                id: '16540', // image_node.
                attributes: [
                    {
                        /* Image node was positioned incorrectly. We shifted it down by updating the y attribute
                        */
                        name: 'y',
                        value: '60'
                    },
                ]
            },
        ],
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.ELEC.3.0.0a.js